import React, { useState, useEffect } from 'react';
import Header from './components/header';
import Footer from './components/footer';
import StayConnected from "./components/stayConnected";
import CBS from "./assets/img/cbs-1.png";
import Cnn1 from "./assets/img/cnn-1.jpg";
import peopleIcon from "./assets/img/people-1.jpg";
import GQIcon from "./assets/img/gq-1.jpg";
import MiamiHerald from "./assets/img/miami-herald-1.jpg";
import ntone from "./assets/img/nt-1.jpg";
import CnbcLogo from './assets/img/cnbc-1.jpg';
import Logo from './assets/img/NGF-logo.svg';
import SEOTags from './common/SEO';
import ReviewForm from './components/reviewForm';
import FAQSection from './components/faq';
import PersonalInjury from './assets/video/Personal_Injury.mp4';
import Rear_End_Collision from './assets/video/Rear_End_Collision.mp4';
import CarAccident from './assets/video/Car_Accidents.mp4';
import DrunkDriving from './assets/video/Drunk_Driving.mp4';
import PedestrianAccident from './assets/video/Pedestrian_Accident.mp4';
import BicycleAccidents from './assets/video/Bicycle_Accidents.mp4';
import MotorcycleAccident from './assets/video/Motorcycle_Accident.mp4';
import SpinalInjury from './assets/video/Spinal_Injury.mp4';
import TruckAccident from './assets/video/Truck_Accident.mp4';
import WhiplashInjury from './assets/video/Whiplash_Injury.mp4';
import Head_On_Collision from './assets/video/Head_On_Collision.mp4';
import personal_Injury_Icon from './assets/img/icons/personal_Injury.svg'
import Car_accident_Icon from './assets/img/icons/Car_accident.svg';
import rear_end_collision_icon from './assets/img/icons/rear_end_collision.svg';
import pedastrian_accident_icon from './assets/img/icons/pedastrian_accident.svg';
import bicycle_accident_icon from './assets/img/icons/bicycle_accident.svg';
import Spinal_Injury_icon from './assets/img/icons/Spinal_Injury.svg';
import motorcycle_accident_icon from './assets/img/icons/motorcycle_accident.svg';
import personal_Injury from './assets/img/icons/personal_Injury.svg';
import Drunk_driving from './assets/img/icons/Drunk_driving.svg';
import Whiplash_accident from './assets/img/icons/Whiplash_accident.svg'
import Truck_Accident from './assets/img/icons/truck_accident.svg';
import Headon_collision from './assets/img/icons/Headon_collision.svg';
import natlie_video_thumbnail from './assets/img/common/natlie-video-thumbnail.jpg';
import AboutImg from './assets/img/common/about-img.jpg'
import { Link, useLocation } from 'react-router-dom';
import { PostDataAPI } from './services/PostDataAPI';


const Home = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const pageSize = 9;
  const [error, setError] = useState(null);

  const [hasMore, setHasMore] = useState(true); // Flag to track if more data is available
  const handleClose = () => setOpen(false);
  const [listNews, setListNews] = useState([]);

  const fetchNews = async () => {
    setLoading(true);
    try {
      const result = await PostDataAPI("news/getAllNews", { page, pageSize }); // Passing page and pageSize
      if (result.success && result.data) {
        debugger
        setListNews(prevNews => [...prevNews, ...result.data]); // Append new data
        if (result.data.length < pageSize) {
          setHasMore(false); // Stop further API calls if the data length is less than pageSize
        }
      } else {
        setError(result.message || "No news available.");
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        setError("Failed to fetch news: " + error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const practiceAreas = [
    {
      id: "personal-injury",
      title: "Personal_Injury",
      desc: "Comprehensive legal support for individuals harmed due to negligence.",
      icon: personal_Injury_Icon,
      color: "#8B1A1A",
      videoKeyword: "justice courtroom law",
      practiceVideo: PersonalInjury,
      link: '/personal-injury'
    },
    {
      id: "rear-end-collision",
      title: "Rear_End_Collision",
      desc: "Protecting victims of sudden-impact crashes and related injuries.",
      icon: rear_end_collision_icon,
      color: "#1A1A2E",
      videoKeyword: "car accident highway",
      practiceVideo: Rear_End_Collision,
      link: '/rear-end-collision'
    },
    {
      id: "car-accidents",
      title: "Car Accidents",
      desc: "Representation for accident victims dealing with injuries, insurance, and recovery.",
      icon: Car_accident_Icon,
      color: "#16213E",
      videoKeyword: "car crash road",
      practiceVideo: CarAccident,
      link: '/car-accidents'
    },
    {
      id: "pedestrian-accident",
      title: "Pedestrian Accident",
      desc: "Advocating for pedestrians injured due to negligent drivers.",
      icon: pedastrian_accident_icon,
      color: "#0F3460",
      videoKeyword: "pedestrian crosswalk city",
      practiceVideo: PedestrianAccident,
      link: '/pedestrian-accident'
    },
    {
      id: "bicycle-accidents",
      title: "Bicycle Accidents",
      desc: "Legal support for cyclists facing injury, liability, and compensation challenges.",
      icon: bicycle_accident_icon,
      color: "#1B4332",
      videoKeyword: "bicycle road cyclist",
      practiceVideo: BicycleAccidents,
      link: '/bicycle-accidents'
    },
    {
      id: "spinal-injury",
      title: "Spinal Injury",
      desc: "Focused representation for life-altering injury cases requiring serious advocacy.",
      icon: Spinal_Injury_icon,
      color: "#6B1C1C",
      videoKeyword: "hospital medical spine",
      practiceVideo: SpinalInjury,
      link: '/spinal-injury'
    },
    {
      id: "motorcycle-accident",
      title: "Motorcycle Accident",
      desc: "Protecting riders injured due to careless or reckless driving.",
      icon: motorcycle_accident_icon,
      color: "#212529",
      videoKeyword: "motorcycle road ride",
      practiceVideo: MotorcycleAccident,
      link: '/motorcycle-accident'
    },
    {
      id: "whiplash-injury",
      title: "Whiplash Injury",
      desc: "Representation for soft tissue and collision-related injury claims.",
      icon: Whiplash_accident,
      color: "#3D1C02",
      videoKeyword: "neck injury pain medical",
      practiceVideo: WhiplashInjury,
      link: '/whiplash-injury'
    },
    {
      id: "drunk-driving",
      title: "Drunk Driving",
      desc: "Legal action for victims harmed by impaired and reckless drivers.",
      icon: Drunk_driving,
      color: "#1C1C1C",
      videoKeyword: "drunk driving DUI accident",
      practiceVideo: DrunkDriving,
      link: '/drunk-driving'
    },
    {
      id: "truck-accident",
      title: "Truck Accident",
      desc: "Strategic legal representation for complex commercial vehicle accident claims.",
      icon: Truck_Accident,
      color: "#1A1A1A",
      videoKeyword: "truck semi highway accident",
      practiceVideo: TruckAccident,
      link: '/truck-accident'
    },
    {
      id: "head-on-collision",
      title: "Head-On Collision",
      desc: "Support for victims of severe and catastrophic impact collisions.",
      icon: Headon_collision,
      color: "#1C0A00",
      videoKeyword: "car crash collision severe",
      practiceVideo: Head_On_Collision,
      link: '/head-on-collision'
    },
  ];

  useEffect(() => {
    //fetchNews();
  }, [])

  useEffect(() => {
    SEOTags(
      "Home | Figgers Law"
    );

    const isReturningVisitor = localStorage.getItem("visited");

    if (!isReturningVisitor) {
      const timer = setTimeout(() => {
        setOpen(true);
        localStorage.setItem("visited", "true"); // Mark as visited
      }, 5000);

      return () => clearTimeout(timer); // Cleanup timeout
    }
  }, []);

  const openVideoModal = () => {

  }
  const [playVideo, setPlayVideo] = useState(false);
  const videoId = "5h9pRlEfL9o";
  return (
    <>

      <Header></Header>
      <div className="page active" id="page-home">

        <section className="hero" id="top">

          <div className="hero-video-screen"></div>
          <div className="hero-video-overlay"></div>

          <div style={{ position: 'absolute', right: 0, top: 0, width: '45%', height: '100%', overflow: 'hidden', opacity: '0.25' }} className="hero-video-area">
            <div style={{ width: '100%', height: '100%', background: "linear-gradient(135deg,#1a0a00,#050a10)", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "12px" }}>
              <div className="hero-play-btn" onClick={openVideoModal}>
                <svg width="28" height="28" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polygon points="5 3 19 12 5 21 5 3" fill="currentColor" stroke="none" /></svg>
              </div>
              <div className="hero-video-label">Watch Natlie G. Figgers</div>
            </div>
          </div>

          <div className="container hero-content">
            <div className="hero-grid">
              <div>
                <div className="hero-tagline">Florida Personal Injury Representation</div>
                <h1>Trusted Legal Advocacy <em>When You Need It Most</em></h1>
                <div className="hero-video">
                  {playVideo ? (
                    <iframe
                      src={`https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&rel=0&disablekb=1&playsinline=1`}
                      title="Figgers Law Video"
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    />
                  ) : (
                    <button
                      className="hero-video-poster"
                      type="button"
                      aria-label="Play Figgers Law video"
                      onClick={() => setPlayVideo(true)}
                    >
                      <img
                        src={natlie_video_thumbnail}
                        alt="Figgers Law video thumbnail"
                      />
                      <span className="hero-video-play">▶</span>
                    </button>
                  )}
                </div>
                <Link to={'/contact-us'} className="hero-slogan">Get a FREE case evaluation today.</Link>
                <div className="hero-seen-on" style={{ marginTop: '28px' }}>
                  <p className='media_logo_asseen'>As seen on:</p>
                  <div className="hero_media_container">
                    <img
                      src={CBS}
                      alt="CBS Sports"
                      className="hero_media_logo"
                    />

                    <img
                      src={Cnn1}
                      alt="CNN"
                      className="hero_media_logo"
                    />

                    <img
                      src={MiamiHerald}
                      alt="Miami Herald"
                      className="hero_media_logo"
                    />

                    <img
                      src={ntone}
                      alt="Miami New Times"
                      className="hero_media_logo"
                    />

                    <img
                      src={CnbcLogo}
                      alt="CNBC"
                      className="hero_media_logo"
                    />

                    <img
                      src={GQIcon}
                      alt="GQ"
                      className="hero_media_logo"
                    />

                    <img
                      src={peopleIcon}
                      alt="People"
                      className="hero_media_logo"
                    />
                  </div>
                </div>
              </div>
              <div>
                <ReviewForm></ReviewForm>
              </div>
            </div>
          </div>
        </section>

        <section className="recognition" id="recognition">
          <div className="container">
            <div
              style={{
                textAlign: "center",
                maxWidth: "680px",
                margin: "0 auto",
              }}
            >
              <div
                className="section-label"
                style={{ justifyContent: "center" }}
              >
                Recognition
              </div>

              <h2
                className="font-display"
                style={{
                  fontSize: "clamp(1.8rem,3vw,2.4rem)",
                  margin: "12px 0",
                }}
              >
                Recognized Legal Leadership &amp; Client Focused Advocacy
              </h2>

              <p className="text-muted">
                Natlie G. Figgers, Esq. brings professional credibility, public
                advocacy, and a strong commitment to justice into every client
                relationship.
              </p>
            </div>

            <div className="recognition-grid">
              <div className="recognition-card">
                <div className="recognition-icon">
                  <svg
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
                    <circle cx="12" cy="8" r="6" />
                  </svg>
                </div>

                <div className="gold-divider"></div>

                <h4 className="font-display">National Black Lawyers</h4>
                <p>Top 40 Under 40</p>
              </div>

              <div className="recognition-card">
                <div className="recognition-icon">
                  <svg
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <circle cx="9" cy="7" r="4" />
                  </svg>
                </div>

                <div className="gold-divider"></div>

                <h4 className="font-display">Florida Memorial University</h4>
                <p>Community Advocacy Recognition</p>
              </div>

              <div className="recognition-card">
                <div className="recognition-icon">
                  <svg
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                  </svg>
                </div>

                <div className="gold-divider"></div>

                <h4 className="font-display">Florida A&amp;M University</h4>
                <p>Board of Trustees Appointment</p>
              </div>

              <div className="recognition-card">
                <div className="recognition-icon">
                  <svg
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 3v18" />
                    <path d="M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1" />
                    <path d="M7 21h10" />
                  </svg>
                </div>

                <div className="gold-divider"></div>

                <h4 className="font-display">Public Advocacy</h4>
                <p>For Justice and Client Rights</p>
              </div>
            </div>


          </div>
        </section>

        {/* <section className="practice" id="practice">
          <div className="container">
            <div className="practice-intro">
              <div className="section-label">Practice Areas</div>

              <h2>
                Injury Representation Focused on Protecting What Matters Most
              </h2>

              <p
                className="text-muted"
                style={{
                  fontSize: "16px",
                  lineHeight: "1.7",
                }}
              >
                If you've been injured due to negligence, unsafe driving, or
                reckless behavior, Figgers Law is here to help you understand
                your legal options and pursue fair compensation.
              </p>
            </div>

            <div className="practice-grid">
              {practiceAreas.map((item) => {

                return (
                  <Link to={item.link}>
                    <div key={item.id} className="practice-card">
                      <video
                        className="practice-card-video"
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="metadata"
                      >
                        <source src={item.practiceVideo} type="video/mp4" />
                      </video>
                      <div className="practice-card-overlay" />

                      <div className="practice-card-content">
                        <div className="practice-card-icon">
                          <img
                            src={item.icon} // Update path if needed
                            alt={item.title}
                          />
                        </div>

                        <h3 className="practice-card-title">{item.title}</h3>

                        <p className='practice-card-desc'>{item.desc}</p>

                        <a href={`/practice/${item.id}`} className="practice-card-link">
                          Learn More
                          <svg
                            width="12"
                            height="12"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                          >
                            <path d="M5 12h14" />
                            <path d="M12 5l7 7-7 7" />
                          </svg>
                        </a>

                      </div>


                    </div>
                  </Link>
                )
              })}
            </div>
          </div>
        </section > */}

        <section className="why" id="why">
          <div className="container">
            <div className="why-grid">
              <div className="why-intro">
                <div className="section-label" style={{ color: "var(--gold)" }}>
                  Why Figgers Law
                </div>

                <h2>Why Injury Victims Choose Figgers Law</h2>

                <p
                  style={{
                    color: "rgba(245,240,232,0.8)",
                    lineHeight: 1.8,
                  }}
                >
                  Choosing legal representation after an injury is a serious decision.
                  Figgers Law is built around focused attorney attention, clear
                  communication, and strategic advocacy tailored to each client's
                  circumstances.
                </p>

                <a
                  href="tel:+8556435291"
                  className="btn-outline-ivory"
                  style={{ marginTop: 28, display: "inline-flex" }}
                >
                  Call Natlie G. Figgers
                </a>
              </div>

              <div className="why-cards">
                <div className="why-card">
                  {/* <div className="why-num">01</div> */}

                  <h4>Attorney-Led Personal Representation</h4>
                  <div className="gold-divider"></div>
                  <p>
                    Your case receives focused legal attention from a professional team
                    committed to your best interests.
                  </p>
                </div>

                <div className="why-card">
                  {/* <div className="why-num">02</div> */}

                  <h4>Compassionate Client Experience</h4>
                  <div className="gold-divider"></div>
                  <p>
                    We understand that injuries affect health, finances, families, and
                    peace of mind.
                  </p>
                </div>

                <div className="why-card">
                  {/* <div className="why-num">03</div> */}

                  <h4>Strategic Legal Advocacy</h4>
                  <div className="gold-divider"></div>
                  <p>
                    Every claim is approached with preparation, precision, and
                    persistence.
                  </p>
                </div>

                <div className="why-card">
                  {/* <div className="why-num">04</div> */}

                  <h4>Clear Communication</h4>
                  <div className="gold-divider"></div>
                  <p>
                    Clients deserve honest guidance, responsive updates, and
                    understandable legal direction.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </section>

        <section className="highlights" id="highlights">
          <div className="container">
            <div className="highlights-intro">
              <div className="section-label">Proven Advocacy</div>

              <h2>Proven Advocacy &amp; Notable Case Highlights</h2>

              <p
                className="text-muted"
                style={{
                  fontSize: 16,
                  lineHeight: 1.7,
                }}
              >
                Results matter but so does the commitment, preparation, and persistence
                behind them. Figgers Law's work reflects a dedication to protecting
                clients when the stakes are highest.
              </p>
            </div>

            <div className="highlights-grid">
              <div className="highlight-card">
                {/* <div className="highlight-num">01</div> */}
                <h3>Thomas Raynard James Exoneration Advocacy</h3>
                <p className="text-muted">
                  Natlie G. Figgers played a major advocacy role in helping secure
                  justice for Thomas Raynard James after decades of wrongful
                  incarceration. This work reflects persistence, investigative
                  commitment, and a deep belief in justice.
                </p>
              </div>

              <div className="highlight-card">
                {/* <div className="highlight-num">02</div> */}
                <h3>Personal Injury &amp; Auto Injury Representation</h3>
                <p className="text-muted">
                  Figgers Law provides focused representation for individuals navigating
                  injury recovery, liability disputes, insurance challenges, and
                  compensation claims.
                </p>
              </div>

              <div className="highlight-card">
                {/* <div className="highlight-num">03</div> */}
                <h3>Client-Centered Legal Advocacy</h3>
                <p className="text-muted">
                  The firm is recognized by clients for professionalism,
                  responsiveness, preparation, and trusted legal guidance throughout the
                  entire legal process.
                </p>
              </div>
            </div>

            {/* <p className="highlights-note">
              Past results and case highlights do not guarantee future outcomes. Each
              case depends on its own facts and circumstances.
            </p> */}
          </div>
        </section>

        <section className="stories" id="stories">
          <div className="container">
            <div className="stories-intro">
              <div className="section-label">Featured Stories</div>

              <h2>Real Stories. Real Advocacy. Real Impact.</h2>

              <p>
                Behind every case is a person, a family, and a difficult chapter in
                life. Figgers Law approaches each matter with preparation, compassion,
                and commitment to meaningful outcomes.
              </p>
            </div>

            <div className="stories-grid">
              {listNews.slice(0, 3).map((news, index) => (
                <div className="story-card">
                  <div className="story-card-icon">
                    <svg
                      width="28"
                      height="28"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      viewBox="0 0 24 24"
                    >
                      <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8l6 6v12a2 2 0 0 1-2 2z" />
                      <path d="M14 2v6h6" />
                    </svg>
                  </div>

                  <h3>{news.title}</h3>

                  <p
                    style={{
                      color: "rgba(245,240,232,0.7)",
                      fontSize: 13,
                      lineHeight: 1.7,
                    }}
                  >
                    {news.shortDescription}
                  </p>

                </div>
              ))}

            </div>
          </div>


        </section>

        <section className="about" id="about">
          <div className="container">
            <div className="about-grid">
              <div
                className="about-image-wrap"
                style={{ position: "relative" }}
              >
                <div className="about-attorney-image">
                  <img
                    src={AboutImg}
                    alt="Natlie G. Figgers, Esq."
                  />
                </div>

                <div className="about-badge">
                  <img
                    className="about-badge-logo"
                    src={Logo}
                    alt="Figgers Law Logo"
                  />

                  <div className="gold-divider"></div>

                  <small>Attorney &amp; Founder</small>
                </div>
              </div>

              <div className="about-content">
                <div className="section-label">Meet the Founder & Managing Attorney</div>

                <h2>Natlie G. Figgers, Esq.</h2>

                <h3>
                  Founder and Managing Attorney

                </h3>

                <p><Link to={'contact-us'} class="btn-gold" data-discover="true" style={{ margin: '7px 0px' }}> Schedule a Confidential Consultation</Link></p>

                <p>
                  Natlie G. Figgers is a nationally recognized Florida attorney whose practice brings together business counsel, complex litigation, and serious personal injury representation.


                </p>

                <p>
                  As the founder and managing attorney of Figgers Law, Natlie advises entrepreneurs, established businesses, executives, and organizations throughout the life cycle of a business, from formation and corporate governance to contract negotiation, contract management, risk assessment, and commercial disputes. Her experience includes negotiating, drafting, and managing sophisticated commercial agreements valued at more than $75 million.


                </p>


              </div>
            </div>
          </div>

          <div className="container about-content" style={{ marginTop: '44px' }}>
            <p>
              Natlie also represents individuals and families in serious injury matters
              involving commercial and institutional defendants. Her injury practice
              focuses on cases involving commercial trucks, fleet and company vehicles,
              unsafe business premises, negligent security, defective products, and
              other forms of corporate negligence. This focused approach allows the firm
              to investigate not only the immediate incident, but also the corporate
              policies, operational failures, contractual relationships, and safety
              practices that may have contributed to the harm.
            </p>

            <p>
              Before and alongside her legal practice, Natlie developed more than 13
              years of experience in human resources leadership, corporate operations,
              compliance, and organizational management. That background gives her a
              practical understanding of how legal decisions affect a company’s
              employees, contracts, finances, operations, and long-term growth.
            </p>

            <p>
              Natlie earned her Juris Doctor from Nova Southeastern University and her
              Bachelor of Science in Criminal Justice, cum laude, from Florida A&amp;M
              University. She is admitted to practice throughout Florida, before the
              United States District Court for the Southern District of Florida, and
              before the United States Court of Appeals for the Eleventh Circuit. She is
              fluent in English and Haitian Kreyol.
            </p>

            <p>Recognition and Professional Distinctions</p>

            <ul className="about-list">
              <li>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                Founder and Managing Attorney of Figgers Law
              </li>

              <li>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                The National Black Lawyers Top 40 Under 40 — 2020 and 2021
              </li>

              <li>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                Top 100 Attorneys — 2020
              </li>

              <li>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                Appointed to the Florida A&amp;M University Board of Trustees
              </li>

              <li>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                Florida Memorial University Most Ardent Community Advocate Award — 2022
              </li>

              <li>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                Circle of Brotherhood Power of Leadership Award — 2026
              </li>

              <li>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                Advocate in the effort that contributed to the exoneration of Thomas
                Raynard James after 32 years of wrongful incarceration
              </li>

              <li>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                Experience negotiating, drafting, and managing commercial agreements
                valued at more than $75 million
              </li>

              <li>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                Admitted to The Florida Bar, the Southern District of Florida, and the
                Eleventh Circuit Court of Appeals
              </li>
            </ul>
          </div>
        </section>

        <section className="process" id="process">
          <div className="container">
            <div className="process-intro">
              <div className="section-label">The Process</div>

              <h2>What Working With Figgers Law Looks Like</h2>

              <p
                className="text-muted"
                style={{
                  fontSize: 16,
                  lineHeight: 1.7,
                }}
              >
                Legal matters can feel overwhelming after an injury. The Figgers Law
                process is designed to make the path forward clear, organized, and
                manageable for every client.
              </p>
            </div>

            <div className="process-grid">
              <div className="process-step">
                
               
                <h4>Free Consultation</h4>
                 <div className="gold-divider"></div>
                <p>
                  We listen to your situation and help you understand possible legal
                  options.
                </p>
              </div>

              <div className="process-step">
            
               
                <h4>Case Evaluation</h4>
                 <div className="gold-divider"></div>
                <p>
                  We review the facts, injuries, liability concerns, and available
                  documentation.
                </p>
              </div>

              <div className="process-step">
         
             
                <h4>Legal Strategy</h4>
                   <div className="gold-divider"></div>
                <p>
                  A focused plan is created based on your case, goals, and
                  circumstances.
                </p>
              </div>

              <div className="process-step">
              
                <h4>Legal Handling</h4>
                  <div className="gold-divider"></div>
                <p>
                  We manage legal communication, claim preparation, and negotiations.
                </p>
              </div>

              <div className="process-step">
              
                <h4>Resolution</h4>
                  <div className="gold-divider"></div>
                <p>
                  We pursue the compensation and outcome your case deserves.
                </p>
              </div>
            </div>

            <div style={{ marginTop: 36 }}>
              <Link to={'/contact-us'}
                className="btn-gold">
                Start Your Consultation
              </Link>
            </div>
          </div>
        </section>

        <section className="testimonials" id="testimonials">
          <div className="container">
            <div className="testimonials-intro">
              <div className="section-label">Client Voices</div>

              <h2>What Clients Say About Figgers Law</h2>

              <p>
                Trust is earned through preparation, communication, advocacy, and care.
              </p>
            </div>

            <div className="testimonials-grid">
              <div className="testimonial-card">
                <div className="quote-icon">
                  <svg
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z" />
                    <path d="M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z" />
                  </svg>
                </div>

                <p>
                  "Natlie was professional, prepared, and attentive throughout the
                  process. I felt informed and supported every step of the way."
                </p>

                <div className="stars">★★★★★</div>

                <div className="testimonial-source">
                  Figgers Law Client
                </div>
              </div>

              <div className="testimonial-card">
                <div className="quote-icon">
                  <svg
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z" />
                    <path d="M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z" />
                  </svg>
                </div>

                <p>
                  "Figgers Law gave me clarity during a stressful time and helped me
                  understand my legal options clearly."
                </p>

                <div className="stars">★★★★★</div>

                <div className="testimonial-source">
                  Figgers Law Client
                </div>
              </div>

              <div className="testimonial-card">
                <div className="quote-icon">
                  <svg
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z" />
                    <path d="M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z" />
                  </svg>
                </div>

                <p>
                  "Responsive, knowledgeable, and committed to helping clients move
                  forward with their lives after injury."
                </p>

                <div className="stars">★★★★★</div>

                <div className="testimonial-source">
                  Figgers Law Client
                </div>
              </div>
            </div>

            <p className="testimonials-note">
              Placeholder testimonials to be replaced with approved client reviews
              before publication.
            </p>
          </div>
        </section>

        <FAQSection></FAQSection>

        <section className="resources" id="resources">
          <div className="container">
            <div className="resources-intro">
              <div className="section-label">Resources</div>

              <h2>Injury Guidance &amp; Legal Resources</h2>

              <p
                className="text-muted"
                style={{
                  fontSize: 16,
                  lineHeight: 1.7,
                }}
              >
                Helpful legal insights for injury victims seeking clarity before making
                important decisions.
              </p>
            </div>

            <div className="resources-grid">
              <div className="resource-card">
                <div className="res-icon">
                  <svg
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 7v14" />
                    <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
                  </svg>
                </div>

                <h4>What to Do After a Car Accident</h4>

                <p>
                  Important steps to protect your health, documentation, and legal
                  rights immediately after a crash.
                </p>

                {/* <div className="res-link">
                  Read
                  <svg
                    width="12"
                    height="12"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </div> */}
              </div>

              <div className="resource-card">
                <div className="res-icon">
                  <svg
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 7v14" />
                    <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
                  </svg>
                </div>

                <h4>Understanding Personal Injury Compensation</h4>

                <p>
                  A simple guide to damages, recovery, and claim considerations for
                  Florida injury victims.
                </p>

                {/* <div className="res-link">
                  Read
                  <svg
                    width="12"
                    height="12"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </div> */}
              </div>

              <div className="resource-card">
                <div className="res-icon">
                  <svg
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 7v14" />
                    <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
                  </svg>
                </div>

                <h4>Common Insurance Claim Mistakes</h4>

                <p>
                  What injury victims should avoid when dealing with insurance companies
                  and adjusters.
                </p>

                {/* <div className="res-link">
                  Read
                  <svg
                    width="12"
                    height="12"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </div> */}
              </div>

              <div className="resource-card">
                <div className="res-icon">
                  <svg
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 7v14" />
                    <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
                  </svg>
                </div>

                <h4>How to Protect Your Legal Rights</h4>

                <p>
                  Practical guidance for documenting and preserving your claim after a
                  personal injury.
                </p>

                {/* <div className="res-link">
                  Read
                  <svg
                    width="12"
                    height="12"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </div> */}
              </div>
            </div>
          </div>
        </section>

        <section className="cta-band">
          <div className="container cta-band-content">
            <div
              className="section-label"
              style={{ justifyContent: "center" }}
            >
              Speak With Figgers Law
            </div>

            <h2>
              Injured? <em>Let Figgers Law</em> Help You Move Forward.
            </h2>

            <p>
              You do not have to navigate the legal process alone. Speak with Figgers
              Law today to understand your options and receive trusted legal guidance.
            </p>

            <div className="cta-band-btns">

              <Link to={'/contact-us'}
                className="btn-gold">
                Free Case Consultation
              </Link>

              <a
                href="tel:+8556435291"
                className="btn-outline-ivory"
              >
                Call Now
              </a>
              {/* 
              <a
                href="#"
                className="btn-outline-ivory"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                Quick Assessment
              </a> */}
            </div>

            <p className="cta-band-fine">
              Confidential consultation · Professional guidance · Focused injury
              representation
            </p>
          </div>
        </section>

      </div >
      <Footer></Footer>
    </>
  );
};
export default Home;
